import { useEffect } from "react";
import { languageState } from "./language";
import { useRecoilValue } from "recoil";

export const PERSIST_KEY_LANGUAGE = "albis:state:language";

export const useStatePersistence = () => {
  const language = useRecoilValue(languageState);

  useEffect(() => {
    // Don't persist language in preview mode - it would affect regular browsing
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("mgnlPreview")) {
      return;
    }
    
    localStorage.setItem(PERSIST_KEY_LANGUAGE, language);
  }, [language]);
};
